import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
import { ArrowRight, Globe, BookOpen, Award } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-[#1e3a5f]" data-id="element-56">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-57">
        <div className="absolute top-0 left-0 w-full h-full bg-[url('https://images.unsplash.com/photo-1523050854058-8df90110c9f1?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')] bg-cover bg-center opacity-10" data-id="element-58"></div>
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-[#f59e0b] rounded-full blur-3xl opacity-20" data-id="element-59"></div>
        <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-[#faf8f5] to-transparent" data-id="element-60"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-61">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-62">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="text-center lg:text-left" data-id="element-63">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-white/10 text-[#f59e0b] text-sm font-medium mb-6 mt-8 border border-white/20" data-id="element-64">
              <span className="flex h-2 w-2 rounded-full bg-[#f59e0b] mr-2" data-id="element-65"></span>
              Admissions Open for 2026
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" data-id="element-66">
              Your Journey to <br data-id="element-67" />
              <span className="text-[#f59e0b]" data-id="element-68">World-Class Education</span>{' '}
              Starts Here
            </h1>

            <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-69">
              We help ambitious students find and secure their place in top
              universities across the globe. Expert guidance from application to
              arrival.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-70">
              <Link to="/programs" className="w-full sm:w-auto" data-id="element-71">
                <Button variant="accent" size="lg" fullWidth className="group" data-id="element-72">
                  Explore Programs
                  <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-73" />
                </Button>
              </Link>
              <Link to="/contact" className="w-full sm:w-auto" data-id="element-74">
                <Button variant="outline" size="lg" fullWidth data-id="element-75">
                  Book Free Consultation
                </Button>
              </Link>
            </div>

            <div className="mt-12 flex items-center justify-center lg:justify-start space-x-8 text-gray-400" data-id="element-76">
              <div className="flex items-center space-x-2" data-id="element-77">
                <Globe className="h-5 w-5 text-[#f59e0b]" data-id="element-78" />
                <span className="text-sm" data-id="element-79">15+ Countries</span>
              </div>
              <div className="flex items-center space-x-2" data-id="element-80">
                <BookOpen className="h-5 w-5 text-[#f59e0b]" data-id="element-81" />
                <span className="text-sm" data-id="element-82">500+ Programs</span>
              </div>
              <div className="flex items-center space-x-2" data-id="element-83">
                <Award className="h-5 w-5 text-[#f59e0b]" data-id="element-84" />
                <span className="text-sm" data-id="element-85">98% Success Rate</span>
              </div>
            </div>
          </motion.div>

          {/* Hero Image/Illustration */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="hidden lg:block relative" data-id="element-86">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl border-4 border-white/10" data-id="element-87">
              <img src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&auto=format&fit=crop&w=1740&q=80" alt="Students studying together" className="w-full h-auto object-cover" data-id="element-88" />

              {/* Floating Cards */}
              <motion.div initial={{
              x: 20,
              opacity: 0
            }} animate={{
              x: 0,
              opacity: 1
            }} transition={{
              delay: 1,
              duration: 0.5
            }} className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-lg flex items-center space-x-3 max-w-xs" data-id="element-89">
                <div className="bg-green-100 p-2 rounded-full" data-id="element-90">
                  <Award className="h-6 w-6 text-green-600" data-id="element-91" />
                </div>
                <div data-id="element-92">
                  <p className="text-xs text-gray-500 font-medium" data-id="element-93">
                    Visa Status
                  </p>
                  <p className="text-sm font-bold text-gray-900" data-id="element-94">
                    Approved Successfully
                  </p>
                </div>
              </motion.div>
            </div>

            {/* Background decorative blob */}
            <div className="absolute -z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[#f59e0b]/10 rounded-full blur-3xl" data-id="element-95"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}